export abstract class SocialPublish {
  public static readonly FIELDS_MAX_LENGTH = new Map([
    ['title', 70],
    ['description', 200],
    ['whatIsHappening', 280],
  ]);
}
